// Mirror of `CATEGORY_STYLE_COLORS` from wandavision/constants/Colors.ts.
// wandavision is the SOURCE OF TRUTH — these are the per-style background colors the
// mobile "Explore Styles" tiles render the SVG over. Guarded by the pinned snapshot in
// categoryStyleColors.spec.js; when wandavision changes, update both files from it.
export const CATEGORY_STYLE_COLORS = {
  heels: "#663E70",
  "hip-hop": "#772424",
  ballet: "#6D5A36",
  "lite-feet": "#6E6302",
  "k-pop": "#722C56",
  dancehall: "#5F3A01",
  contemporary: "#590202",
  jazz: "#4C155A",
  locking: "#201E68",
  salsa: "#2B5006",
  "dance-workout": "#1A3B5D",
  krump: "#773024",
  popping: "#1C3A6D",
  "open-style": "#3A7D44",
  "jazz-funk": "#723066",
  whacking: "#5A2C70",
  house: "#7A2824",
  breaking: "#1C1C3A",
};

// Fallback background for any slug without an explicit color (grey).
export const CATEGORY_STYLE_COLOR_FALLBACK = "#C8CBCB";
